export default {"src":"/_next/static/media/parallel_handcuffs_64.0057b19f.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};